import { SidebarConf } from "./model";

export const DEFAULT_SIDEBAR_CONF: SidebarConf = {
  isShow: true,
};
